import { Tooltip } from 'react-bootstrap'
import { OverlayTrigger } from 'react-bootstrap'
import { RiRadioButtonLine } from 'react-icons/ri'
import { UserResponse } from '../Api/User/models'

interface Props {
    mobile: boolean
    handleExtractData: () => void
    connectionStatus: boolean
    userInfo: UserResponse | null
}

export const Connector = ({ mobile, handleExtractData, connectionStatus, userInfo }: Props) => {
    return (
        <div
            className={`${mobile ? 'd-flex align-items-center justify-content-center gap-3 px-2 py-3 text-secondary hover-primary' : 'mt-5 mb-3'}`}
            role="button"
            onClick={() => handleExtractData()}
        >
            <OverlayTrigger
                placement={mobile ? "bottom" : "right"}
                overlay={<Tooltip>{connectionStatus ? 'Estás conectado.' : 'Haz click para conectar.'}</Tooltip>}
            >
                <div className={`d-flex align-items-center justify-content-center gap-3 ${connectionStatus ? 'text-success' : 'text-danger'}`}>
                    <RiRadioButtonLine size={24} />
                    {mobile &&
                        <div className={`text-xxs text-center ${connectionStatus ? 'text-success' : 'text-danger'}`}	>
                            {connectionStatus ? userInfo?.name?.toUpperCase() : 'OFFLINE'}
                        </div>
                    }
                </div>

            </OverlayTrigger>
            {!mobile &&
                <div className={`text-xxs text-center mt-1 text-break ${connectionStatus ? 'text-success' : 'text-danger'}`}	>
                    {connectionStatus ? userInfo?.name?.toUpperCase() : 'OFFLINE'}
                </div>
            }
        </div>

    )
}
